export const SLOT_ITEM = {
  BANANA: 1,
  LEMON: 2,
  CHERRY: 3,
  STRAWBERRY: 4,
  COKE: 5,
  CHIPS: 6,
  HAMBURGER: 7,
  PIZZA: 8,
  CLOVER: 9,
  DICE: 10,
  CHEST: 11,
  LAMA: 12,
};

export const SLOT_ITEMS = [
  SLOT_ITEM.BANANA,
  SLOT_ITEM.LEMON,
  SLOT_ITEM.CHERRY,
  SLOT_ITEM.STRAWBERRY,
  SLOT_ITEM.COKE,
  SLOT_ITEM.CHIPS,
  SLOT_ITEM.HAMBURGER,
  SLOT_ITEM.PIZZA,
  SLOT_ITEM.CLOVER,
  SLOT_ITEM.CHEST,
  SLOT_ITEM.LAMA,
];

export const PATH_TO_LOCATION = {
  1: ["11", "21", "31", "41", "51"],
  2: ["12", "22", "32", "42", "52"],
  3: ["13", "23", "33", "43", "53"],
  4: ["11", "22", "33", "42", "51"],
  5: ["13", "22", "31", "42", "53"],
  6: ["12", "21", "31", "41", "52"],
  7: ["12", "23", "33", "43", "52"],
  8: ["11", "21", "32", "43", "53"],
  9: ["13", "23", "32", "41", "51"],
};

export const PATH_TO_POINTS = {
  1: [
    [45, 45],
    [537, 45],
  ],
  2: [
    [45, 171],
    [537, 171],
  ],
  3: [
    [45, 297],
    [537, 297],
  ],
  4: [
    [45, 60],
    [291, 312],
    [537, 60],
  ],
  5: [
    [45, 282],
    [291, 30],
    [537, 282],
  ],
  6: [
    [45, 156],
    [168, 60],
    [414, 60],
    [537, 156],
  ],
  7: [
    [45, 186],
    [168, 282],
    [414, 282],
    [537, 186],
  ],
  8: [
    [45, 30],
    [168, 30],
    [414, 312],
    [537, 312],
  ],
  9: [
    [45, 312],
    [168, 312],
    [414, 30],
    [537, 30],
  ],
};

export const PATH_TO_COLOR = {
  1: "#FF2DB4",
  2: "#FF9B0F",
  3: "#8CFF00",
  4: "#50B90A",
  5: "#46FFC8",
  6: "#23B9FF",
  7: "#505FFF",
  8: "#AA50FF",
  9: "#914119",
};

export const ELEMENT_TYPE = {
  normal: 1,
  scatter: 2,
  wild: 3,
  bonus: 4,
  jackpot: 5,
};

export const TAG_SLOT = "tag_slot";
